import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { hasPreviewAccess, isPublicPath, routeGateDecision } from '@/lib/preview-access';

/**
 * Gates a route until public launch (`routeGateDecision`): through with the
 * preview-access flag (/preview?key=...) or a signed-in session; everyone else
 * is redirected to the public marketing home (which shows the waitlist gate).
 * Not a security boundary: RLS and the portal and crew tokens are.
 */
export function RouteGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const decision = routeGateDecision({
    previewAccess: hasPreviewAccess() || isPublicPath(pathname),
    signedIn: !!user,
    authLoading: loading,
  });
  if (decision === 'redirect') return <Navigate to="/" replace />;
  if (decision === 'wait') return null;
  return <>{children}</>;
}
